module.exports = __webpack_public_path__ + "img/2.130a3c9c.png";